import React, { useState, useEffect } from 'react';
import { cloudStore } from '../firebase';
import { collection, query, where, doc, setDoc, arrayUnion, updateDoc, getDocs, getDoc } from 'firebase/firestore';
import { ShowText } from './ShowText';

export function AllChat() {
    const [click, setclick] = useState(0)
    const [chatCollection, setchatCollection] = useState([])
    useEffect(() => {
        getDocs(query(collection(cloudStore, "chatHistory"), where("Dialogue", "!=", null)))
            .then((querySnapshot) => {
                const data = querySnapshot.docs.map((doc) => doc.data());
                setchatCollection(data)
            })
    }, [click]);

    // 
    useEffect(() => {
        const fetchData = () => {
            getDocs(query(collection(cloudStore, "chatHistory"), where("Dialogue", "!=", null)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setchatCollection(data)
                })
        };
        fetchData()

        const intervalId = setInterval(() => {
            fetchData();
        }, 1000 * 5);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    // 第一次
    useEffect(() => {
        if (chatCollection.length === 0) {
            getDocs(query(collection(cloudStore, "chatHistory"), where("Dialogue", "!=", null)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setchatCollection(data)
                })
        }
    });

    const [showContact, setshowContact] = useState(false)
    const [showwhichContact, setshowwhichContact] = useState("")
    // const [oneUserChat, setoneUserChat] = useState("")
    const openContact = (e) => {
        let value = e.target.dataset.value
        // console.log(chatCollection)
        if (showContact === true) {
            setshowContact(false)
        } else {
            setshowContact(true)
            setshowwhichContact(value)
            let clickvalue = click
            setclick(clickvalue + 1)
            let filterchatCollection = chatCollection.filter((content) => {
                // console.log(content.Dialogue[0][Object.keys(content.Dialogue[0])].chatName)
                return content.Dialogue[0][Object.keys(content.Dialogue[0])].userID === value
            })
            // console.log(filterchatCollection)
            // setoneUserChat(filterchatCollection)
            //点击后更新ChatLength，计算有多少未读信息。逻辑结构为，此时此刻的chat数量-上次查看时的chat数量=未查看数量
            filterchatCollection.map((content) => {
                let array = content.Dialogue
                let userID = array[0][Object.keys(array[0])].userID
                let chatName = array[0][Object.keys(array[0])].chatName
                let newarray = array.filter((content) => {
                    return content[Object.keys(content)].userName === chatName
                })

                const docRef = doc(cloudStore, "chatHistory", userID);
                return updateDoc(docRef, { ChatLength: newarray.length });
            })
        }
    }

    const [chatText, setchatText] = useState("")
    const handleInputChange = (e) => {
        let { value } = e.target
        setchatText(value)
    }

    const sendText = async () => {
        let clickvalue = click
        setclick(clickvalue + 1)
        let button = document.querySelector("#text");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.classList.add("disappear") }, 4500);

        let userName = localStorage.getItem("currentLoginUser")
        let time = new Date()
        let day = time.getDate();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let hours = time.getHours().toString().padStart(2, '0');
        let minutes = time.getMinutes().toString().padStart(2, '0');
        let seconds = time.getSeconds().toString().padStart(2, '0');
        let finalDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds

        if (userName !== null) {
            setchatText("")
            const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
            const userData = userExist.docs.map(doc => doc.data());
            const userID = userData[0].Personal_Information.userID;
            const chatExist = await getDoc(doc(collection(cloudStore, 'chatHistory'), showwhichContact));
            if (chatExist.exists()) {
                const docData = {
                    [finalDate]: {
                        userName: userName,
                        userID: userID,
                        showtime: finalDate,
                        realtime: time,
                        text: chatText,
                        chatName: userName
                    }
                }
                const docRef = doc(cloudStore, "chatHistory", showwhichContact);
                updateDoc(docRef, { Dialogue: arrayUnion(docData) });
            } else {
                const docData = {
                    "Dialogue": [{
                        [finalDate]: {
                            userName: userName,
                            userID: userID,
                            showtime: finalDate,
                            realtime: time,
                            text: chatText,
                            chatName: userName
                        }
                    }]
                }
                setDoc(doc(cloudStore, "chatHistory", showwhichContact), docData)
            }
        } else {
            text = document.createTextNode("请登录呦~");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    const handleKeyDown1 = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            sendText();
        }
    };

    let userID = localStorage.getItem("currentLoginUserID");
    let eachCollection = null
    if (chatCollection.length > 0) {
        let filterchatCollection = chatCollection.filter((content) => {
            // console.log(content.Dialogue[0][Object.keys(content.Dialogue[0])].chatName)
            return content.Dialogue[0][Object.keys(content.Dialogue[0])].chatName !== localStorage.getItem("currentLoginUser")
        })
        filterchatCollection.sort((a, b) => b[`${userID}unread`] - a[`${userID}unread`]);
        eachCollection = filterchatCollection.map((content) => {
            let array = content.Dialogue
            let userID = array[0][Object.keys(array[0])].userID
            let chatName = array[0][Object.keys(array[0])].chatName
            let ChatLength = content.ChatLength
            let newarray = array.filter((content) => {
                return content[Object.keys(content)].userName === chatName
            })
            let redAlert = "nothing"
            let unread = newarray.length
            if (ChatLength) {
                unread = newarray.length - ChatLength
                if (unread > 0) {
                    redAlert = "redAlert"
                }
            } else {
                if (unread > 0) {
                    redAlert = "redAlert"
                }
            }

            const docRef = doc(cloudStore, "chatHistory", userID);
            updateDoc(docRef, { [`${userID}unread`]: unread })

            return (
                <div key={userID} className="each_chat" >
                    <div
                        onClick={(e) => openContact(e)}
                        data-value={userID}
                        className="forClick"
                    ></div>
                    <div><strong>ID: </strong>{userID}</div>
                    <div><strong>User Name: </strong>{chatName}</div>
                    <div className={redAlert} style={{ display: "none" }}>{unread}</div>
                </div >
            )
        })
    }

    return (
        <div className='collection_content' style={{ marginTop: "50px" }}>
            <div className='h2bg'>
                <h2>Chat</h2>
            </div>
            <div className="store">
                {eachCollection}
            </div>
            {showContact === true ?
                <>
                    <div
                        className='forclickBG'
                        onClick={(e) => openContact(e)}></div>

                    <div className='showContact'>
                        <div className='forContact'>
                            <ShowText chatExist={chatCollection} chatUser={showwhichContact} />
                            <form>
                                <label htmlFor="text"></label>
                                <textarea
                                    id="text"
                                    type="text"
                                    placeholder="回复消息"
                                    onChange={(e) => { handleInputChange(e) }}
                                    onKeyDown={(e) => handleKeyDown1(e)}
                                    value={chatText}
                                ></textarea>
                            </form>
                        </div>
                    </div>
                </> : null

            }
        </div>
    );
}